import LogoutButton from './logout';

function Logout() {
  return (
    <LogoutButton />
  );
}

export default Logout;
